import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { CustomValidators, LabeledFormControl, assert } from 'ats-ui-lib';
import { JobApplicationComplementaryFormQuestionTypeEnum } from './job-application-complementary-form.model';

export class FactoryFormAnswerOpenQuestion {
  static create(
    fb: UntypedFormBuilder,
    id: string,
    label: string,
    required: boolean,
    enableAttachment: boolean,
    requiredAttachment: boolean,
    sequence: number,
  ): UntypedFormGroup {
    assert(fb);

    const validators = required ? [CustomValidators.requiredIgnoreWhiteSpace] : null;

    if (!enableAttachment) {
      return fb.group({
        id: [id],
        label: [label],
        type: [JobApplicationComplementaryFormQuestionTypeEnum.OpenQuestion],
        answerDescription: new LabeledFormControl(`${sequence}`, '', validators),
        required: [required],
      });
    }

    return fb.group({
      id: [id],
      label: [label],
      type: [JobApplicationComplementaryFormQuestionTypeEnum.OpenQuestion],
      answerDescription: new LabeledFormControl(`${sequence}`, '', validators),
      required: [required],
      enableAttachment: [true],
      requiredAttachment: [requiredAttachment && required],
      files: [[], requiredAttachment && required ? [Validators.required] : null],
    });
  }
}
